import { useQuery } from "@tanstack/react-query";
import { t } from "ttag";

import { ErrorState } from "@/app/components/legacy-components";
import {
  PastAppointmentsCards,
  PastAppointmentsTable,
} from "@/features/coaching/screens/past-appointments/components";
import {
  CoachingHubHeader,
  MyAgendaSection,
  OneOnOneSupportSection,
} from "@/features/coaching/sections";
import { consultationsQueriesStore } from "@/features/consultations/api";
import { usePageTitle } from "@/shared/hooks";
import { Card, History2Icon, TableSkeleton } from "@/shared/ui";

export const CoachingHub = () => {
  usePageTitle(t`Coaching hub`);

  const {
    data: sessions,
    isLoading,
    isSuccess,
    isError,
  } = useQuery(
    consultationsQueriesStore.consultations.appointments._ctx.list._ctx.past
      ._ctx.journeySupport,
  );

  return (
    <>
      <CoachingHubHeader />

      <MyAgendaSection />

      <OneOnOneSupportSection />

      <Card.Root ghost>
        <Card.Title icon={History2Icon}>{t`Past appointments`}</Card.Title>

        {isLoading && <TableSkeleton columns={5} rows={5} />}

        {isSuccess && (
          <>
            <PastAppointmentsTable sessions={sessions} />
            <PastAppointmentsCards sessions={sessions} />
          </>
        )}

        {isError && <ErrorState />}
      </Card.Root>

      {/* <GroupCoachingSection /> */}

      {/* <BookOneOnOneDropdownMenu /> */}
    </>
  );
};
